import { urlParam } from "../config";

const NAME = "_ss_ck";
const MAX_AGE = 30 * 24 * 60 * 60;

//The click that brought this visitor, kept for the brand site. Someone who
//lands on an affiliate page and later buys on optiloss.in or thunderofzeus.in
//directly sends it with the order, and the CRM credits that affiliate. The
//affiliate landings and the brand site share the registrable domain, so the
//cookie is written there; the last click wins. It never leaves the browser
//except with an order, and the CRM still checks the click it names.
export function attributionCookie() {
	const transactionId = urlParam("transaction_id");

	if (!transactionId || !/^[A-Za-z0-9_-]+$/.test(transactionId)) {
		return;
	}

	const labels = window.location.hostname.split(".");
	let cookie =
		NAME +
		"=" +
		transactionId +
		"; Path=/; Max-Age=" +
		MAX_AGE +
		"; SameSite=Lax";

	if (labels.length >= 2 && !/^\d+$/.test(labels[labels.length - 1])) {
		cookie += "; Domain=" + labels.slice(-2).join(".");
	}

	if (window.location.protocol === "https:") {
		cookie += "; Secure";
	}

	document.cookie = cookie;
}
